import { useContext, useEffect, useRef, useState } from "react";
import { OrderContext } from "../ContextApi/context";

const TheWeightSelect = (props) => {

    const [order, setOrder] = useContext(OrderContext);

    const [currentWeightValue, setCurrentWeightValue] = useState(parseFloat(props.weightValue) / 1000);

    useEffect(() => {
        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);
        if (theItm != -1 && order.Orders[theItm].weightValue !== undefined) {
            // המרה מגרמים לק"ג לתצוגה
            setCurrentWeightValue(parseFloat(order.Orders[theItm].weightValue) / 1000);
            
        }
    }, [order])

    const addToMount = () => {
        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);
        // הוספת weightValue (בגרמים)
        const currentWeight = order.Orders[theItm].weightValue || 0;
        order.Orders[theItm].weightValue = parseInt(currentWeight) + parseInt(props.weightValue);
        console.log(theItm);
        setOrder({ ...order });
    }

    const lessToMount = () => {
        let theItm = order.Orders.findIndex(itm => itm.orderItemId == props.itemId);
        // הפחתת weightValue (בגרמים)
        const currentWeight = order.Orders[theItm].weightValue || 0;
        order.Orders[theItm].weightValue = parseInt(currentWeight) - parseInt(props.weightValue);

        if (order.Orders[theItm].weightValue > 0) {
            setOrder({ ...order });
        }
        else
        //remover from order
        {
            let filt = order.Orders.filter(itm => itm.orderItemId != props.itemId)
            order.Orders = filt;
            setOrder({ ...order });

            props.remFromOrder();
        }
    }

    return (
        !props.hideBtns ?
            <div className={"prodPlusMinus"}>
                {/* <div className={"mountLn"}>משקל</div> */}
                {!props.hideBtns && <button type="button" className={"btnReset plusBtn"} aria-label="הוסף משקל" onClick={() => addToMount()}>+</button>}
                <div className={!props.hideBtns && "mountNum"}>
                    {currentWeightValue} ק"ג
                </div>
                {!props.hideBtns && <button type="button" className={"btnReset minusBtn"} aria-label="הפחת משקל" onClick={() => lessToMount()}>-</button>}
            </div>
            :
            <div>
                {currentWeightValue} ק"ג
            </div>

    );

}

export default TheWeightSelect;